<div style="height: 100%">
    <div class="flex-wrap">
        <h4>Citar alumnos a nivelación</h4>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    </div>
    <div class="flex-wrap">
        <div class="inline-flex" style="padding-right: 5px">
            <mat-form-field *ngIf="materias$ | async as materias; else loadingMat" class="full-width">
                <mat-select placeholder="Seleccione una materia" (selectionChange)="getAlumnos($event)">
                    <mat-option *ngFor="let materia of materias" [value]="materia.id">{{materia.nombreCompleto}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="inline-flex" style="padding-left: 5px">
            <mat-form-field *ngIf="dataSource" class="full-width">
                <input matInput placeholder="Filtrar por nombre" (keyup)="applyFilter($event.target.value)" autocomplete="off">
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="dataSource" style="height: calc(100% - 155px);overflow: auto; padding: 4px;">
        <mat-table #table [dataSource]="dataSource" matSort class="mat-elevation-z2">
            <ng-container *ngFor="let column of displayedColumns">
                <ng-container matColumnDef="{{column}}" *ngIf="column === 'Alumnos'; else franja">
                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                    <mat-cell *matCellDef="let element">{{element.alumno}}</mat-cell>
                </ng-container>
                <ng-template #franja>
                    <ng-container matColumnDef="{{column}}">
                        <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <ng-container *ngIf="getFranja(element, column).conflicto && getFranja(element, column).conflicto.isConflicto; else editable">
                                <mat-icon style="cursor: default;" matTooltip="Reservado por {{getFranja(element, column).conflicto.profesor}} {{getFranja(element, column).conflicto.materia}}">
                                    not_interested
                                </mat-icon>
                            </ng-container>
                            <ng-template #editable>
                                <p style="margin: 1px;">
                                    <mat-checkbox [value]="getFranja(element, column)" (change)="franjaChange($event)" [checked]="getFranja(element, column).citado" [disableRipple]="true" [disabled]="!getFranja(element, column).isEditable"></mat-checkbox>
                                </p>
                            </ng-template>
                        </mat-cell>
                    </ng-container>
                </ng-template>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
        </mat-table>
        <mat-paginator #paginator [pageSize]="15" [pageSizeOptions]="[15, 30, 50]" [showFirstLastButtons]="true">
        </mat-paginator>
    </div>
    <div class="flex-wrap" *ngIf="dataSource" style="padding: 15px 0;">
        <span class="spacer"></span>
        <button mat-button="" (click)="close()">Cancelar</button>
        <button mat-raised-button="" color="primary" (click)="guardar()">Aceptar</button>
    </div>
    <ng-template #loadingMat>
        <mat-spinner [mode]="'indeterminate'" [color]="'primary'"></mat-spinner>
    </ng-template>
    <ng-container *ngIf="loading">
        <mat-spinner [mode]="'indeterminate'" [color]="'primary'"></mat-spinner>
    </ng-container>
</div>